"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NestedMenu;

var _react = _interopRequireWildcard(require("react"));

var _Box = _interopRequireDefault(require("@mui/material/Box"));

var _Menu = _interopRequireDefault(require("@mui/material/Menu"));

var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));

var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));

var _ExpandMore = _interopRequireDefault(require("@mui/icons-material/ExpandMore"));

var _material = require("@mui/material");

var _styles = require("@mui/material/styles");

var _ChevronRight = _interopRequireDefault(require("@mui/icons-material/ChevronRight"));

var _ChevronLeft = _interopRequireDefault(require("@mui/icons-material/ChevronLeft"));

var _excluded = ["leftIcon", "rightIcon"];

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledMenuItemContainer = (0, _styles.styled)(_material.Grid)(function (_ref) {
  var theme = _ref.theme;
  return {
    background: theme.palette.nestedSubmenu.primary,
    flexDirection: 'column',
    position: 'absolute',
    borderRadius: '5px'
  };
});
var StyledMenuItemLabel = (0, _styles.styled)(_MenuItem.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 1rem;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  width: 100%;\n  display: flex;\n  align-items: center;\n"])));

var RecursiveMenuItem = function RecursiveMenuItem(_ref2) {
  var _ref$current, _ref$current2;

  var leftIcon = _ref2.leftIcon,
      rightIcon = _ref2.rightIcon,
      props = _objectWithoutProperties(_ref2, _excluded);

  var theme = (0, _styles.useTheme)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var ref = (0, _react.useRef)(null);

  var handleMouseLeave = function handleMouseLeave() {
    setOpen(false);
  };

  return /*#__PURE__*/_react.default.createElement(_material.Grid, _extends({}, props, {
    container: true,
    ref: ref,
    onMouseEnter: function onMouseEnter() {
      return setOpen(true);
    },
    sx: {
      position: 'relative',
      borderTop: props.borderTop && "1px solid ".concat(theme.palette.grey[300]),
      borderBottom: props.borderBottom && "1px solid ".concat(theme.palette.grey[300])
    },
    onMouseLeave: handleMouseLeave
  }), /*#__PURE__*/_react.default.createElement(StyledMenuItemLabel, {
    onClick: function onClick(e) {
      e.stopPropagation();

      if (props.onClick) {
        props.onClick();
      }

      setOpen(true);
    }
  }, leftIcon || props.children && props.alignment === 'left' && /*#__PURE__*/_react.default.createElement(_ChevronLeft.default, {
    size: "small"
  }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: {
      flexGrow: 1
    }
  }, props.label), rightIcon || props.children && props.alignment === 'right' && /*#__PURE__*/_react.default.createElement(_ChevronRight.default, {
    size: "small"
  })), /*#__PURE__*/_react.default.createElement(StyledMenuItemContainer, {
    sx: {
      display: open ? 'flex' : 'none',
      left: props.alignment === 'right' ? "".concat(ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.clientWidth, "px") : null,
      right: props.alignment === 'left' ? "".concat(ref === null || ref === void 0 ? void 0 : (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.clientWidth, "px") : null
    }
  }, props.children));
};

function NestedMenu(_ref3) {
  var text = _ref3.text,
      items = _ref3.items,
      alignment = _ref3.alignment;
  var theme = (0, _styles.useTheme)();

  var _React$useState = _react.default.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var open = Boolean(anchorEl);

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Box.default, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    onClick: handleClick,
    size: "small",
    sx: {
      ml: 2,
      borderRadius: '5px'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body1",
    color: "secondary"
  }, text), /*#__PURE__*/_react.default.createElement(_ExpandMore.default, {
    color: "secondary",
    fontSize: "large"
  }))), /*#__PURE__*/_react.default.createElement(_Menu.default, {
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    onClick: handleClose,
    disableScrollLock: true,
    PaperProps: {
      elevation: 0,
      sx: {
        background: theme.palette.nestedSubmenu.primary,
        overflow: 'visible',
        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
        mt: 1.5,
        '& .MuiAvatar-root': {
          width: 32,
          height: 32,
          ml: -0.5,
          mr: 1
        }
      }
    },
    transformOrigin: {
      horizontal: 'right',
      vertical: 'top'
    },
    anchorOrigin: {
      horizontal: 'right',
      vertical: 'bottom'
    }
  }, items.map(function (item, idx) {
    var _item$subItems;

    return /*#__PURE__*/_react.default.createElement(RecursiveMenuItem, {
      key: idx,
      label: item.label,
      alignment: alignment,
      rightIcon: item.rightIcon,
      leftIcon: item.leftIcon,
      borderTop: item.borderTop,
      borderBottom: item.borderBottom,
      onClick: item.subItems ? null : function (e) {
        return item.onClick(e, item.value);
      }
    }, (_item$subItems = item.subItems) === null || _item$subItems === void 0 ? void 0 : _item$subItems.map(function (subItem, idx2) {
      return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
        key: idx2,
        onClick: function onClick() {
          return item.onClick(subItem.value);
        }
      }, subItem.label);
    }));
  })));
}